// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import {
  InventoryFilters,
  UNPAGINATED_INVENTORY_LIMIT,
  assembliesInventoryResponseSchema,
} from '@/inventory/api/types';
import queryString from 'query-string';

/**
 * Gets products/assemblies in inventory with optional filters
 *
 * Endpoint: GET /v1/inventory/products
 *
 * @param filters - Optional filters to apply to the assemblies inventory query
 * @returns Promise resolving to assemblies inventory response
 */
export async function getAssembliesInventory(filters?: InventoryFilters) {
  const url = '/v1/inventory/products';
  const response = await api.get(url, {
    paramsSerializer: (parameters) => queryString.stringify(parameters),
    params: { ...filters, limit: UNPAGINATED_INVENTORY_LIMIT },
  });
  return parseResponse(assembliesInventoryResponseSchema, response.data, {
    schemaName: 'AssembliesInventory',
    endpoint: url,
  });
}
